_.mixin({ "eachSlice": function(obj, size, iterator, context) {
  for (var i=0, l=obj.length; i < l; i+=size) {
    iterator.call(context, obj.slice(i,i+size), i, obj);
  } }});

_.mixin({
    chunk: function (array, unit) {
        if (!_.isArray(array)) return array;
        unit = Math.abs(unit);
        var results = [],
            length = Math.ceil(array.length / unit);

        for (var i = 0; i < length; i++) {
            results.push(array.slice( i * unit, (i + 1) * unit));
        }
        return results;
    }
});